import { ToolBtn } from "../ToolBtn";
import secondaryComponents from "../..";
import { useState } from "react";
import { useSelector } from "react-redux";

export const CheckoutTable = ({ btnStyle = {} }) => {
  const [isTable, setIsTable] = useState(false);
  const tableInfo = useSelector((state) => state?.checkoutReducer?.table);

  return (
    <>
      <div className="w-100">
        <ToolBtn
          text="Table"
          borderColor={"transparent"}
          onClick={() => setIsTable(true)}
          style={btnStyle}
          contentText={tableInfo ? tableInfo?.name : null}
        />
      </div>

      <secondaryComponents.Modal
        closeModal={() => setIsTable(false)}
        isActive={isTable}
        width={1360}
      >
        <secondaryComponents.TableView
          resetView={() => setIsTable(false)}
          // openBillsWidget={() => resetMenuViews("isOpenBillsWidget")}
        />
      </secondaryComponents.Modal>
    </>
  );
};
